// test525
(525 && 0);
